// Metadata for the "Classic" template — picked up by templates/registry.js
// and mirrored (by hand, for now) in engine's static templates registry so
// the dashboard can list it without engagement needing its own backend.
const manifest = {
  key: 'classic',
  name: 'Classic',
  description: 'Default carousel + entry form layout used since launch.',
  thumbnail: '/assets/images/templates/classic-thumbnail.png',
  // When false: hidden from the dashboard's Template tab and excluded entirely from the production build.
  is_deploy: true
};

export default manifest;
